import { useState } from 'react';
import { Box, Typography, type SxProps, type Theme } from '@mui/material';

export interface BrandLogoProps {
  /** URL do arquivo (ex.: `/brand/dts-logo.png`). Servido de `apps/web/public`. */
  src: string;
  alt?: string;
  /** Altura da imagem (px ou responsivo). Largura é `auto`. */
  height?: number | { [key: string]: number };
  /** Cor do texto de fallback quando a imagem não carrega. */
  fallbackColor?: string;
  sx?: SxProps<Theme>;
}

/**
 * Marca DTS. Renderiza a imagem em `src`; se o arquivo não existir (ainda não
 * foi colado em `public/brand/`), cai num wordmark textual "DTS" — assim a UI
 * nunca fica quebrada com um ícone de imagem faltando.
 */
export function BrandLogo({
  src,
  alt = 'DTS Tecnologia',
  height = 32,
  fallbackColor = 'inherit',
  sx,
}: BrandLogoProps): JSX.Element {
  const [broken, setBroken] = useState(false);

  if (broken) {
    return (
      <Typography
        component="span"
        sx={{
          fontWeight: 800,
          letterSpacing: '0.08em',
          lineHeight: 1,
          color: fallbackColor,
          fontSize: typeof height === 'number' ? height * 0.7 : 22,
          ...sx,
        }}
      >
        DTS
      </Typography>
    );
  }

  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      onError={() => setBroken(true)}
      sx={{ height, width: 'auto', display: 'block', ...sx }}
    />
  );
}
